import React from 'react'
import { useNavigate } from 'react-router-dom'
import RecordFormsPanel from './RecordFormsPanel'

/** ECDD Source of funds / wealth — published forms with placement ecdd.sof. */
export default function EcddFormsRail({
  ecddId,
  patronId = '',
  patronLabel = '',
  readOnly = false,
  onAssignmentsChange,
}) {
  const navigate = useNavigate()
  if (!ecddId) return null

  return (
    <RecordFormsPanel
      subjectType="ecdd"
      subjectId={String(ecddId)}
      subjectLabel={patronLabel || 'This ECDD'}
      patronId={patronId}
      placement="ecdd.sof"
      readOnly={readOnly}
      title="Additional forms"
      description="Published forms placed on ECDD Source of funds / wealth. Hardcoded SoW outreach stays above."
      onAssignmentsChange={onAssignmentsChange}
      onAssigned={(assignment, form) => {
        if (form?.facing === 'internal' && assignment?.id) {
          navigate(`/compliance-safe/forms/assignments/${assignment.id}`)
        }
      }}
    />
  )
}
